let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("14Ui1")).then(() => parcelRequire('dJ2yL'));